import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";

export const UserForm = ({ defaultValues, onSubmit, isSaving }) => {
  const { register, handleSubmit, reset, formState: { errors } } = useForm({ defaultValues });

  // Re-seed the form when defaultValues arrive from the parent fetch
  useEffect(() => {
    if (defaultValues) reset(defaultValues);
  }, [defaultValues, reset]);

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row className="g-3 mb-4">
        <Col sm={6}>
          <Form.Group controlId="fname">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="First name"
              isInvalid={!!errors.fname}
              {...register("fname", { required: "First name is required" })}
            />
            <Form.Control.Feedback type="invalid">
              {errors.fname?.message}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group controlId="lname">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Last name"
              isInvalid={!!errors.lname}
              {...register("lname", { required: "Last name is required" })}
            />
            <Form.Control.Feedback type="invalid">
              {errors.lname?.message}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Button type="submit" variant="primary" disabled={isSaving}>
        {isSaving ? (
          <><Spinner animation="border" size="sm" className="me-2" />Saving…</>
        ) : (
          "Save Profile"
        )}
      </Button>
    </Form>
  );
};
